import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  List,
  Grid,
  Typography,
  ListItem,
  ListItemButton,
  ListItemText,
  FormControlLabel,
  TextField,
  InputAdornment,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation } from 'react-i18next';
import { faLongArrowLeft, faLongArrowRight, faSearch  } from '@fortawesome/pro-light-svg-icons';
import clsx from 'clsx'
import CustomToolTip from '../../UI/ToolTip/ToolTip';
import Checkbox from '../../UI/Checkbox/StyledCheckbox';
import cloneDeep from 'lodash/cloneDeep';
import { objectSize } from '../../../../common/utilities/utilitiesFunctions'
import { AutoSizer, List as VirtualizedList } from 'react-virtualized';

const DualListBoxWrapper = styled('div')(({ theme }) => ({
  '& .dualbox': {
    display: 'flex',
    width: '100%',
    textAlign: 'right',
    paddingBottom: '5px',
    marginTop: '7px',
    position: 'relative',
  },
  '& .boxWrapper': {
    position: 'relative',
    width: '100%',
  },
  '& .rootBox': {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'hidden',
    border: '2px outset #6ea0d7',
    height: 220,
    borderRadius: '5px'
  },
  '& .headerText': {
    padding: '5px 5%',
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '15px',
    zIndex: 1,
    width: '100%',
    height: 40,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  '& .boxList': {
    overflow: 'auto',
    height: 180,
  },
  '& .icons': {
    alignSelf: 'center',
    padding: '10px',
    fontSize: 'x-large',
    color: '#6ea0d7',
  },
  '& .listItems': {
    borderBottom: '1px solid #e6edf5',
    '&:hover': {
      backgroundColor: '#e6edf5',
    }
  },
  '& .subHeader': {
    color: '#878787',
    flex: 1
  },
  '& .containerLabels': {
    display: 'flex',
    width: '90%'
  },
  '& .inputCheckbox': {
    display: 'inline-block'
  },
  '& .selectAll': {
    position: 'absolute',
    left: 16
  },
  '& .iconClass': {
    marginLeft: 'auto',
  },
  '& .iconSelected': {
    color: '#6EA0D7'
  },
  '& .iconDeselected': {
    color: '#DCDCDC'
  },
  '& .mainContainer': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '25px',
    border: '1px solid #dcdcdc',
    borderRadius: '5px',
    padding: '8px',
    backgroundColor: '#f9f9f9',
  },
  '& .searchInput': {
    width: '100%',
    border: 'none',
    outline: 'none',
  },
}));

class PinnedSubheaderList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      includedSEL: {},
      excludedSEL: {},
      keyIncluded: Math.random(),
      keyExcluded: Math.random(),
      searchQuery: '',
    }
  }

  SelectTarget = (data, target) => {
    data.forEach(element => {
      element.target = target
    });
    return data
  }
  initObject = (data) => {
    let object = {};
    data.forEach(element => {
      object[element.id] = cloneDeep(element)
    });
    return object
  }

  handleItem = (item, target, event) => {
    let auxList = {}
    auxList = cloneDeep(this.state[target])
    if (event.target.checked) {
      auxList[item.id] = item;
    }
    else {
      delete auxList[item.id]
    }
    this.setState({
      [target]: auxList,
      searchQuery: '',
    });
  }

  allSelected = (list, target) => {
    return objectSize(this.state[list]) === this.props[target].length && this.props[target].length > 0
  }

  isChecked = (item, target) => {
    return this.state[target][item.id] === undefined ? false : true
  }

  handleSelectAll = (list, target, event) => {
    let result = {};
    if (event.target.checked) {
      result = this.initObject(this.props[target])
    }
    this.setState({
      [list]: result
    })
  }

  customButtonState = (item) => {
    const { customBandName } = this.props
    let auxClass = typeof item.value[customBandName] === 'undefined' || !item.value[customBandName] ? "iconDeselected" : "iconSelected";
    return clsx("iconClass", auxClass)
  }

  handleCustomButtom = (item) => {
    const { dataSelected, updateIncluded, target, customFeature, customBandName } = this.props;
    if (customFeature) {
      let includedFinal = this.initObject(dataSelected);
      if (typeof includedFinal[item.id].value[customBandName] === 'undefined' || !includedFinal[item.id].value[customBandName]) {
        includedFinal[item.id].value[customBandName] = true;
      }
      else {
        includedFinal[item.id].value[customBandName] = false;
      }
      updateIncluded(target, includedFinal)
    }
  }

  handleMove = (target, direction) => {
    const { includedSEL, excludedSEL } = this.state;
    const { dataSelected, data, moveSelectedAll, moveAll } = this.props;
    if (typeof moveSelectedAll !== 'undefined') {
      let includedFinal = this.initObject(dataSelected);
      let excludedFinal = this.initObject(data);
      if (direction === 'toLeft') {
        for (let item in excludedSEL) {
          delete excludedFinal[item]
          includedFinal[item] = excludedSEL[item];
        }
        this.setState({
          excludedSEL: {},
          keyExcluded: Math.random(),
        })
      }
      else {
        for (let item in includedSEL) {
          delete includedFinal[item]
          excludedFinal[item] = includedSEL[item];
        }
        this.setState({
          includedSEL: {},
          keyIncluded: Math.random(),
        })
      }
      moveSelectedAll(target, includedFinal, excludedFinal)
    }
    if (typeof moveAll !== 'undefined') {
      moveAll(target, direction)
    }
  }

  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  filteredData = (data) => {
    return data.filter(item => item.label.toLowerCase().includes(this.state.searchQuery.toLowerCase()));
};

render() {
  const { keyIncluded, keyExcluded, searchQuery } = this.state;
  const {
    t, dataSelected, data, handleChangeDualBox = () => {}, handleUpdates = () => {}, target, subHeader,
    subHeaderStyle,
    rightBoxText = t('DualListBox.excluded'),
    leftBoxText = t('DualListBox.included'),
    moveAllToRightText = t('DualListBox.excludeAll'),
    moveAllToLeftText = t('DualListBox.includeAll'),
    selectableItem, customFeature, icon
  } = this.props;
  const includedAux = this.filteredData(this.SelectTarget(dataSelected, target));
  const excludedAux = this.filteredData(this.SelectTarget(data, target));

  const handleListItemClick = (item, status) => {
    handleChangeDualBox(item, status, handleUpdates);
    this.setState({ searchQuery: '' });
  };

  const rowRenderer = ({ key, index, style, data }) => {
    const item = data[index];
    return (
      <ListItem className="listItems" style={style} key={key} disablePadding>
        <ListItemButton onClick={() => handleListItemClick(item, data === includedAux ? 'excluded' : 'included')}>
        {selectableItem ? (
          <FormControlLabel
            control={
              <Checkbox
                checked={this.isChecked(item, data === includedAux ? 'includedSEL' : 'excludedSEL')}
                key={`item-${item.value}-${data === includedAux ? keyIncluded : keyExcluded}-${data === includedAux ? 'CBI' : 'CBE'}`}
                onClick={(event) => { this.handleItem(item, data === includedAux ? 'includedSEL' : 'excludedSEL', event); }}
                className="inputCheckbox"
              />
            }
            label={<ListItemText primary={`${item.label}`} />}
          />
        ) : (
          <ListItemText primary={`${item.label}`} />
        )}
        {typeof customFeature !== 'undefined' ? (
          <FontAwesomeIcon
            onClick={() => { this.handleCustomButtom(item); }}
            className={this.customButtonState(item)}
            icon={icon}
          />
        ) : (
          ''
        )}
        </ListItemButton>
      </ListItem>
    );
  };

  return (
    <DualListBoxWrapper>
      <div className="containerLabels">
        <Typography className="subHeader" color="textSecondary" style={subHeaderStyle}>{subHeader}</Typography>
      </div>
      <div className="mainContainer">
        <TextField
          placeholder="Search"
          variant="outlined"
          size="small"
          value={searchQuery}
          onChange={this.handleSearchChange}
          className="searchInput"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <FontAwesomeIcon icon={faSearch} style={{ color: '#888' }} />
              </InputAdornment>
            ),
          }}
        />
        <Grid className="dualbox">
          <div className={clsx("boxWrapper", "rootBox")}>
            {selectableItem ? (
              <FormControlLabel
                className="selectAll"
                control={
                  <Checkbox
                    disabled={dataSelected.length === 0}
                    checked={this.allSelected('includedSEL', 'dataSelected')}
                    onClick={(event) => { this.handleSelectAll('includedSEL', 'dataSelected', event); }}
                    className="inputCheckbox"
                  />
                }
                label={<ListItemText primary={'Select All'} />}
              />
            ) : (
              ''
            )}
            <Typography className="headerText">{leftBoxText}</Typography>
            <AutoSizer disableHeight>
              {({ width }) => (
                <VirtualizedList
                  width={width}
                  height={180}
                  rowHeight={50}
                  rowCount={includedAux.length}
                  rowRenderer={(props) => rowRenderer({ ...props, data: includedAux })}
                  className="boxList"
                />
              )}
            </AutoSizer>
          </div>
          <div className="icons">
            <CustomToolTip
              titleText={moveAllToLeftText}
              jsx={<div><FontAwesomeIcon icon={faLongArrowLeft} onClick={() => this.handleMove(target, 'toLeft')} /></div>}
            />
            <CustomToolTip
              titleText={moveAllToRightText}
              jsx={<div><FontAwesomeIcon icon={faLongArrowRight} onClick={() => this.handleMove(target, 'toRight')} /></div>}
            />
          </div>
          <div className={clsx("boxWrapper", "rootBox")}>
            {selectableItem ? (
              <FormControlLabel
                className="selectAll"
                control={
                  <Checkbox
                    disabled={data.length === 0}
                    checked={this.allSelected('excludedSEL', 'data')}
                    onClick={(event) => { this.handleSelectAll('excludedSEL', 'data', event) }}
                    className="inputCheckbox"
                  />
                }
                label={<ListItemText primary={'Select All'} />}
              />
            ) : (
              ''
            )}
            <Typography className="headerText">{rightBoxText}</Typography>
            <AutoSizer disableHeight>
              {({ width }) => (
                <VirtualizedList
                  width={width}
                  height={180}
                  rowHeight={40}
                  rowCount={excludedAux.length}
                  rowRenderer={(props) => rowRenderer({ ...props, data: excludedAux })}
                  className="boxList"
                />
              )}
            </AutoSizer>
          </div>
        </Grid>
      </div>
    </DualListBoxWrapper>
  );
  }
}

PinnedSubheaderList.propTypes = {
}

export default withTranslation('common')(PinnedSubheaderList);
